import { Component, OnInit, Inject } from '@angular/core';
import { Router  } from '@angular/router';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { OpdDocsStatusComponent } from '../../opd/opd-docs-status/opd-docs-status.component';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-opd-modal',
  templateUrl: './opd-modal.component.html',
  styleUrls: ['./opd-modal.component.css']
})
export class OpdModalComponent implements OnInit {
    placements = ['left'];
    popoverTitle = 'Are you sure?';
    popoverMessage = 'Are you really <b>sure</b> you want to do this?';
    confirmText = 'Yes <i class="fas fa-check"></i>';
    cancelText = 'No <i class="fas fa-times"></i>';
    confirmClicked = false;
    cancelClicked = false;fileDeleting:boolean=false;
    OpdForm: FormGroup;loading:boolean=false;submitted:boolean=false;dataLoaded:boolean=false;uploading:boolean=false;
    allUploads=[];s3url='';bds=[];treatments=[];doctors=[];hospitals=[];myrole:string='';opdChk:boolean=false;bds_copy=[];doctors_copy=[];hospitals_copy=[];treatments_copy=[];prescriptionStatus=0;invalidName:boolean=false;invalidTreatment:boolean=false;invalidBd:boolean=false;
    constructor(public dialogRef: MatDialogRef<OpdModalComponent>,@Inject(MAT_DIALOG_DATA) public data: MatDialog,private dialog:MatDialog,
    private router:Router,private sharedapi:SharedService, private leadapi:LeadsService,private formBuilder: FormBuilder) 
    {
        this.OpdForm = this.formBuilder.group({ 
            'patient_name' : [null, Validators.required],
            'mobile' : [null, Validators.required],
            'patient_age' : [null],
            'gender' : [null],
            'doctor_id' : [null, Validators.required],
            'hospital_id' : [null, Validators.required],
            'treatment_id' : [null, Validators.required],
            'user_id' : [null, Validators.required],
            'consultation_fee' : [null, Validators.required],
            'appointment_date' : [null, Validators.required],
            'appointment_time' : [null, Validators.required],
            'prescription' : [null],
            'doctor_share' : [null],
            'hospital_share' : [null],
            'glamyo_share' : [null],
            'surgery_suggested' : [0],
            'followup_date' : [null],
            'status': [0, Validators.required],
            'approved_status': [null],
            'comments': [null],
            'consultation_type':[]
        });
        
    }

    openOpdDocsStatusDialog(obj)
    {
        const dialogRef = this.dialog.open(OpdDocsStatusComponent, {
            width: '50%',
            height: '40%',
            data:{data:obj}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
            if(result){
                this.getOpdDetails();
            }
           
        });
    }

    ngOnInit(): void 
    {
        this.getbds();this.getTreatment();
        this.getDoctor();this.getHospital();
        this.getOpdDetails();
        this.sharedapi.getRole()
        .subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
        this.s3url = localStorage.getItem('s3url');
    }

    setSearchValue(type){
        if(type=='lead_owner'){
            $("#ownerSearch").val('');
            $("#ownerSearch").focus();
            this.bds= this.bds_copy;
        }else if(type=='doctor'){
            $("#doctorSearch").val('');
            $("#doctorSearch").focus();
            this.doctors= this.doctors_copy;
        }else if(type=='hospital'){
            $("#hospitalSearch").val('');
            $("#hospitalSearch").focus();
            this.hospitals= this.hospitals_copy;
        }else if(type=='treatment'){
            $("#treatmentSearch").val('');
            $("#treatmentSearch").focus();
            this.treatments= this.treatments_copy;
        }
    }

    searchOnSelect(searchtText: string, type){
        if(type == 'lead_owner'){
             this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
        }else if(type == 'doctor'){
            this.doctors = this.sharedapi.searchData(searchtText, this.doctors_copy, "name");
        }else if(type == 'hospital'){
            this.hospitals = this.sharedapi.searchData(searchtText, this.hospitals_copy, "name");
        }else if(type == 'treatment'){
            this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
        }
    }

    getApprovedStatus(Srcstatus){
        let status = '';
        switch(Srcstatus)
        {
            case 1:
            status = 'Approved';
            break;
            case 2:
            status = 'Rejected';
            break;
            case 3:
            status = 'High Risk';
            break;
            case 4:
            status = 'Low Risk';
            break;
        }
        return status;
    }
    
    async updateOpd()
    {   
        this.submitted = true;
        this.loading = true;
        // stop here if form is invalid
        if (this.OpdForm.invalid) {
            this.loading = false;
            return;
        }

        if(this.OpdForm.controls['patient_name'].value.trim()=='NA' || this.OpdForm.controls['patient_name'].value.trim()=='N/A'){
            this.loading = false;
            this.invalidName= true;
            return; 
        }else{
            this.invalidName= false; 
        }

        if(this.OpdForm.controls['treatment_id'].value=='37' || this.OpdForm.controls['treatment_id'].value==37){
            this.loading = false;
            this.invalidTreatment= true;
            return; 
        }else{
            this.invalidTreatment= false; 
        }
        if(this.OpdForm.controls['user_id'].value=='21' || this.OpdForm.controls['user_id'].value==21){
            this.loading = false;
            this.invalidBd= true;
            return; 
        }else{
            this.invalidBd= false; 
        }
        this.leadapi.updateOpd(this.data,this.OpdForm.value)
        .subscribe((data:any) => {
            this.submitted = false;
            this.loading = false;
            if(data.status)
            {
                this.sharedapi.presentToast(data.msg);
                this.getOpdDetails();
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error => 
            {
                this.sharedapi.checkError(error);
            });
    }

    get f() { return this.OpdForm.controls; }

    async selectFile(event)
    {
        this.uploading = true;
        let file = event.target.files.item(0);
        console.log(file);
        const formData = new FormData();  
        formData.append('file', file); 
        await this.leadapi.uploadOpdFile(this.data,formData)
        .subscribe((data:any) => {
            this.uploading = false;
            if(data.status)
            {
                this.sharedapi.presentToast('File uploaded Successful');
                this.getOpdDetails();
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error => 
            {
                this.uploading = false;
                this.sharedapi.checkError(error);
            });
    }

    getOpdDetails()
    {
        this.dataLoaded = false;
        this.leadapi.getOpdDetails(this.data).subscribe(
        (data:any) => {
            this.dataLoaded = true;
            if(data.lead)
            {
                this.OpdForm.controls['patient_name'].setValue(data.lead.lead_name);
                this.OpdForm.controls['mobile'].setValue(data.lead.mobile);
                this.OpdForm.controls['treatment_id'].setValue(data.lead.treatment_id);
                this.OpdForm.controls['user_id'].setValue(data.lead.user_id);
                this.OpdForm.controls['patient_age'].setValue(data.lead.patient_age);
                this.OpdForm.controls['gender'].setValue(data.lead.gender);
            }
            if(data && data.status)
            {
                this.allUploads = data.uploads;
                this.opdChk = true;
                this.OpdForm.controls['patient_name'].setValue(data.data.patient);
                this.OpdForm.controls['mobile'].setValue(data.data.phone);
                this.OpdForm.controls['doctor_id'].setValue(data.data.doctor_id);
                this.OpdForm.controls['hospital_id'].setValue(data.data.hospital_id);
                this.OpdForm.controls['treatment_id'].setValue(data.data.treatment_id);
                this.OpdForm.controls['user_id'].setValue(data.data.user_id);
                this.OpdForm.controls['consultation_fee'].setValue(data.data.billed_amt);
                this.OpdForm.controls['consultation_type'].setValue(data.data.consultation_type);
                if(this.myrole=='1')
                {
                    this.OpdForm.controls['doctor_share'].setValue(data.data.doctor_share);
                    this.OpdForm.controls['hospital_share'].setValue(data.data.hospital_share);
                    this.OpdForm.controls['glamyo_share'].setValue(data.data.glamyo_share);
                }
                this.prescriptionStatus = data.data.prescription_status;
                this.OpdForm.controls['surgery_suggested'].setValue(data.data.surgery_suggested);
                if(data.data.surgery_suggested==1 && data.data.followup_date)
                this.OpdForm.controls['followup_date'].setValue(new Date(data.data.followup_date*1000));
                this.OpdForm.controls['appointment_date'].setValue(new Date(data.data.appointment_date*1000));
                this.OpdForm.controls['appointment_time'].setValue(data.data.appointment_time);
                this.OpdForm.controls['status'].setValue(data.data.status);
                this.OpdForm.controls['approved_status'].setValue(data.data.approved_status);
                if(data.data.comments){
                    this.OpdForm.controls['comments'].setValue(data.data.comments);
                }
                
            }else{
                if(data.error_type!='no')
                this.sharedapi.presentToast('Error Occured');
            }
        },
        error => {
            this.sharedapi.checkError(error);
        });
    }

    CloseModal(): void {
        this.dialogRef.close();
    }
    
    async getbds()
    {
        this.leadapi.getbds().subscribe((data:any) => {
            if(data.status)
            {
                this.bds = data.data;
                this.bds_copy= this.bds;
            }else{
                this.bds = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    

    async getTreatment()
    {
        await this.leadapi.getTreatments().subscribe((data:any) => {
            if(data.status)
            {
                this.treatments = data.data;
                this.treatments_copy= this.treatments;
            }else{
                this.treatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    
    async getDoctor()
    {
        await this.leadapi.getdoctors().subscribe((data:any) => {
            if(data.status)
            {
                this.doctors = data.data;
                this.doctors_copy= this.doctors;
            }else{
                this.doctors = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    
    async getHospital()
    {
        await this.leadapi.gethospitals().subscribe((data:any) => {
            if(data.status)
            {
                this.hospitals = data.data;
                this.hospitals_copy= this.hospitals;
            }else{
                this.hospitals = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    
    selectPrescription(event)
    {
        const file = (event.target as HTMLInputElement).files[0];
        this.OpdForm.patchValue({
          prescription: file
        });
        this.OpdForm.get('prescription').updateValueAndValidity();
    }

    removeFile(fileId)
    {
        this.fileDeleting = true;
        this.leadapi.deleteOpdFiles(fileId).subscribe((data:any) => {
            this.fileDeleting = false;
            if(data.status)
            {
                this.getOpdDetails();
            }else{
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    
}
